var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"status0 p-5"},[_vm._v(_vm._s(_vm.$t('no_data_report_content')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }